import * as React from 'react';

import Grid, { IGridProps } from '../layoutComponents/Grid';

export interface IContainerProps extends IGridProps {
  /**
   * Sets container width to be responsive i.e. 100%
   */
  fluid?: boolean;
}

// Container sizes based on breakpoints
const containerSizes = ['xl'];

const Container: React.FC<IContainerProps> = props => {
  const fluidWidth = '100%';
  const maxWidth = props.fluid ? '' : containerSizes;
  return (
    <Grid
      maxWidth={maxWidth}
      width={props.fluid ? fluidWidth : ''}
      mx="auto"
      {...props}
    >
      {props.children}
    </Grid>
  );
};

Container.displayName = 'Container';

export default Container;
